var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMOrdens(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "m-ordens",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.838,
    height: 24.767,
    viewBox: "0 0 17.838 24.767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_10",
    "data-name": "Uni\\xE3o 10",
    d: "M-4093.522,4710.521l-2.232-2.232a.837.837,0,0,1-.181-.913.835.835,0,0,1,.773-.517h5.813a2.515,2.515,0,0,0,2.512-2.511v-6.162c0-1.386,1.674-2.309,1.674,0v6.162a4.19,4.19,0,0,1-4.187,4.185h-3.793l.8.8a.837.837,0,0,1,0,1.183.834.834,0,0,1-.592.246A.834.834,0,0,1-4093.522,4710.521Zm-9.478-12.94v-5.163a4.19,4.19,0,0,1,4.187-4.187h3.792l-.8-.8a.837.837,0,0,1,0-1.185.838.838,0,0,1,1.184,0l2.232,2.233a.833.833,0,0,1,.182.911.838.838,0,0,1-.773.518h-5.814a2.513,2.513,0,0,0-2.511,2.511v5.163c0,.775-.525,1.406-.987,1.406C-4102.676,4698.987-4103,4698.6-4103,4697.582Z",
    transform: "translate(4103 -4686)",
    fill: "#54e046"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "wire-transfer",
    d: "M13.25,19.669a.837.837,0,0,0,.837-.837v-.7a2.7,2.7,0,0,0,.7-5.253l-2.551-.85a1.028,1.028,0,0,1,.325-2h1.111a1.386,1.386,0,0,1,1.317.95.838.838,0,0,0,1.589-.53,3.057,3.057,0,0,0-2.494-2.061V7.669a.837.837,0,0,0-1.674,0v.7a2.7,2.7,0,0,0-.7,5.253l2.551.85a1.028,1.028,0,0,1-.325,2H12.825a1.388,1.388,0,0,1-1.318-.95.837.837,0,0,0-1.588.53,3.055,3.055,0,0,0,2.494,2.061v.718a.837.837,0,0,0,.837.837Z",
    transform: "translate(-4.332 -0.868)",
    fill: "#54e046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMOrdens);
export default __webpack_public_path__ + "static/media/m-ordens.f1d52d99ac722321124d400362b80a34.svg";
export { ForwardRef as ReactComponent };